import { render, staticRenderFns } from "./MicrobialLoadofNeatSemen.vue?vue&type=template&id=4a46ba66&scoped=true&"
import script from "./MicrobialLoadofNeatSemen.vue?vue&type=script&lang=js&"
export * from "./MicrobialLoadofNeatSemen.vue?vue&type=script&lang=js&"
import style0 from "./MicrobialLoadofNeatSemen.vue?vue&type=style&index=0&id=4a46ba66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a46ba66",
  null
  
)

export default component.exports